<template>
  <div class="pa-2">
    <v-layout wrap v-for="doc in docs" :key="doc.documentId">
       <v-flex xs12 md12 lg6>
         <v-card>
           <div class="pa-2">{{doc.title}}</div>
           <v-divider/>
           <v-card-text v-html="doc.content" style="height: 140px;overflow: hidden"/>
           <v-divider/>
           <v-card-actions>
             <v-spacer/>
             <v-btn text outlined color="red" @click="()=> { deleteId = doc.documentId; deleteConfirmDialog = true;}">Delete</v-btn>
             <v-btn text outlined :to="`/docs/update/${doc.documentId}`" color="green">Update</v-btn>
           </v-card-actions>
         </v-card>
       </v-flex>
    </v-layout>
    <div class="text-center">
      <v-progress-circular indeterminate color="green" v-if="loading"/>
      <h2 v-if="loadingError">{{loadingError}}</h2>
      <v-btn v-if="loadingError" @click="getDocs">RETRY</v-btn>
    </div>
    <v-dialog v-model="deleteConfirmDialog" max-width="400">
      <v-card>
        <v-card-title>Confirm</v-card-title>
        <v-card-text>Do you want to delete this doc? It can't be undone</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="deleteConfirmDialog = false">Cancel</v-btn>
          <v-btn @click="deleteDoc" dark color="red">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "all",
  data() {
    return {
      loading: false,
      loadingError: null,
      deleteConfirmDialog: false,
      deleteId: null,
      docs: []
    }
  },
  methods: {
    async deleteDoc(){
      this.deleteConfirmDialog = false;
      try {
        const {data} = await this.$http.get("/docs/delete/"+this.deleteId);
        if(data.statusCode === 0){
          this.docs.splice(this.docs.indexOf(this.docs.filter(el=> el.documentId === this.deleteId)[0]), 1)
          this.deleteId = null;
          this.$message.success("Successful");
        }else {
          this.$message.error(data.error ? data.error.message : "Unknown Error");
        }
      }catch (e) {
        this.$message.error(e.toString());
      }
    },
    async getDocs() {
      this.loading = true;
      this.loadingError = null;
      try {
        const {data} = await this.$http.get("/docs/list");
        if(data.statusCode === 0){
          this.docs = data.results
        }else {
          this.loadingError = data.error ? data.error.message : "Unknown Error";
        }
      }catch (e) {
        this.loadingError = e.toString()
      }
      this.loading = false
    }
  },
  mounted() {
    this.getDocs();
  }
}
</script>

<style scoped>

</style>